import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const useTransformName = () => {
  const { t } = useTranslation();

  const transformName = useCallback(
    (
      firstName?: string | null,
      lastName?: string | null,
      inactive?: boolean
    ): string =>
      (firstName || lastName
        ? `${firstName ? firstName : ""}${
            lastName ? (firstName ? " " : "") + lastName : ""
          }`
        : t("global.notAvailable")) +
      (inactive ? ` (${t("global.inactive")})` : ""),
    [t]
  );

  return transformName;
};

export default useTransformName;
